import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

export const MTWhiteTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#000',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    boxShadow: '0px 8px 20px rgba(0,0,0,0.3)',
    padding: '8px 12px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxHeight: 200,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
  },
}))
